import { AST } from '@handlebars/parser';
import {
  getHandlebarsMergeTagFromStatement,
  getHandlebarsSnippetTagFromStatement,
} from '../../../../../utils';
import { createSnippetTokenForMustacheStatement } from './createSnippetTokenForMustacheStatement';
import { createMergeTagTokenForMustacheStatement } from './createMergeTagTokenForMustacheStatement';

export const processTokensInStatements = (unprocessedStatements: AST.Statement[]) =>
  unprocessedStatements.map((statement) => {
    const snippetStatement = getHandlebarsSnippetTagFromStatement(statement);
    if (snippetStatement) return createSnippetTokenForMustacheStatement(snippetStatement);

    const mergeTagStatement = getHandlebarsMergeTagFromStatement(statement);
    if (mergeTagStatement) return createMergeTagTokenForMustacheStatement(mergeTagStatement);

    return statement;
  });
